module.exports = __webpack_public_path__ + "img/freddy-profile-min.a75f6a44.jpg";